import { CSSProperties, ReactElement } from "react";
import { Table } from "@tanstack/react-table";
import { cn } from "@/lib/utils";
import { TableHead, TableBody } from "@/components/molecules/table";

interface DataTableProps<TData> {
  table: Table<TData>;
  onRowClick?: (data: TData) => void;
  getRowClassName?: (data: TData) => string;
  getRowStyle?: (data: TData) => CSSProperties;
  rowWrapper?: (data: TData, tr: ReactElement) => ReactElement;
  emptyMessage?: string;
  /** Cap the height so the header (and pinned columns) stay in view while scrolling */
  stickyHeader?: boolean;
}

export function DataTable<TData>({
  table,
  onRowClick,
  getRowClassName,
  getRowStyle,
  rowWrapper,
  emptyMessage,
  stickyHeader = false,
}: DataTableProps<TData>) {
  return (
    <div className={cn("relative w-full overflow-auto", stickyHeader && "max-h-[70vh]")}>
      <table className="w-full caption-bottom text-sm">
        <TableHead headerGroups={table.getHeaderGroups()} sticky={stickyHeader} />
        <TableBody
          rows={table.getRowModel().rows}
          onRowClick={onRowClick}
          getRowClassName={getRowClassName}
          getRowStyle={getRowStyle}
          rowWrapper={rowWrapper}
          emptyMessage={emptyMessage}
        />
      </table>
    </div>
  );
}
